import { Pipe, PipeTransform, inject } from '@angular/core';
import { FormatDateArrayPipe } from 'lib';
import { EnterpriseMembershipDto } from 'lib';

@Pipe({
    name: 'formatInstanceStatus',
    standalone: true
})
export class FormatInstanceStatusPipe implements PipeTransform {
    private formatDateArrayPipe = inject(FormatDateArrayPipe);


    transform(enterprise: EnterpriseMembershipDto): string  {
        if (!enterprise) return '';

        if (enterprise.status === 'PENDING') {
            return 'Pending';
        }

        if (enterprise.status === 'ACTIVE') {
            if (enterprise.confirmedBy?.username && enterprise?.confirmedDatetime) {
                const formattedDate = this.formatDateArrayPipe.transform(enterprise.confirmedDatetime);
                return `Confirmed by ${enterprise.confirmedBy.username} on ${formattedDate}`;
            } else {
                return 'Confirmed';
            }
        }

        if (enterprise.status === 'INACTIVE') {
            if (enterprise.confirmedBy?.username && enterprise?.confirmedDatetime) {
                const formattedDate = this.formatDateArrayPipe.transform(enterprise.confirmedDatetime);
                return `Rejected by ${enterprise.confirmedBy.username} on ${formattedDate}`;
            } else {
                return 'Rejected';
            }
        }

        return '';
    }

}
